import { combineReducers } from 'redux'
import UserReportReducer from './reducers/user-report.reducer'

const ReportReducers = combineReducers({
    users: UserReportReducer,
})

export default ReportReducers
export type RootState = ReturnType<typeof ReportReducers>
